import * as consts from '@/constant/shipment-details';

export default {
  methods: {
    getFreightMode(freightMode) {
      let type = '';
      switch (freightMode) {
        case consts.FREIGHT_AIR:
          type = 'Air';
          break;
        case consts.FREIGHT_OCEAN:
          type = 'Ocean';
          break;
        case consts.FREIGHT_LAND:
          type = 'Land';
          break;
        default:
          type = '';
      }
      return type;
    },

    getShipmentFrom(statusShipment) {
      let type = '';
      switch (statusShipment) {
        case consts.FROM_INSTANTPRICE:
          type = 'INSTANT PRICE';
          break;
        case consts.FROM_RFQ:
          type = 'RFQ';
          break;
        case consts.FROM_CONTRACT:
          type = 'CONTRACT';
          break;
        case consts.FROM_INSTANTQUOTE:
          type = 'Instant Quote';
          break;
        default:
          type = '';
      }
      return type;
    },

    getShipmentType(shipmentType) {
      const item = shipmentType.replace(/SEA/g, '');
      let type = '';
      if (item.toUpperCase() === consts.SHIPMENT_AIRCARGO) {
        type = 'Air Cargo';
      } else if (item.toUpperCase() === consts.SHIPMENT_AIRCOURIER) {
        type = 'Air Courier';
      } else if (item.toUpperCase() === consts.SHIPMENT_FCL) {
        type = 'FCL';
      } else if (item.toUpperCase() === consts.SHIPMENT_SEABREAKBULK) {
        type = 'Ocean Breakbulk';
      } else if (item.toUpperCase() === consts.SHIPMENT_AIRBREAKBULK) {
        type = 'Air Breakbulk';
      } else if (item.toUpperCase() === consts.SHIPMENT_BARGE) {
        type = 'Barge';
      } else if (item.toUpperCase() === consts.SHIPMENT_LCT) {
        type = 'LCT';
      } else {
        type = item;
      }
      return type;
    },

    getTextUnitQuantity(freightType, satuan) {
      let text = '';
      if (freightType && satuan) {
        if (freightType.includes('FCL')) {
          const fclunit = 'container';
          text =
            satuan.toLowerCase() === fclunit
              ? 'Container'
              : `Container (${satuan})`;
        } else {
          text = satuan;
        }
      }
      return text;
    },

    getProductType(type) {
      let newType = '';
      if (type === consts.PRODUCT_GENCO) {
        newType = 'General Cargo';
      }
      if (type === consts.PRODUCT_SC) {
        newType = 'Special Cargo';
      }
      if (type === consts.PRODUCT_DG) {
        newType = 'Dangerous Goods';
      }
      return newType;
    },

    getServiceType(type) {
      let currenttype = '-';
      switch (type) {
        case consts.SERVICE_PORT_TO_PORT:
          currenttype = 'Port to Port';
          break;
        case consts.SERVICE_DOOR_TO_PORT:
          currenttype = 'Door to Port';
          break;
        case consts.SERVICE_DOOR_TO_DOOR:
          currenttype = 'Door to Door';
          break;
        case consts.SERVICE_PORT_TO_DOOR:
          currenttype = 'Port to Door';
          break;
        default:
          currenttype = '-';
      }
      return currenttype;
    },

    getImageOtif(otif, type, active) {
      let image = '';
      switch (otif) {
        case consts.OTIF_BOOKED:
          if (type === 'LAND') {
            if (active === true) {
              image = require('@/assets/image/icon/ms-booked-land-blue.svg');
            } else {
              image = require('@/assets/image/icon/ms-booked-land.svg');
            }
          } else {
            image = require('@/assets/image/icon/ms-booked.svg');
          }
          break;
        case consts.OTIF_SCHEDULED:
          if (type === 'LAND') {
            if (active === true) {
              image = require('@/assets/image/icon/ms-scheduled-land-blue.svg');
            } else {
              image = require('@/assets/image/icon/ms-scheduled-land.svg');
            }
          } else {
            image =
              type === 'OCEAN'
                ? require('@/assets/image/icon/ms-scheduled-ocean.svg')
                : require('@/assets/image/icon/ms-schedule.svg');
          }
          break;
        case consts.OTIF_PICKUP:
        case consts.OTIF_DELIVERY:
          image = require('@/assets/image/icon/ms-pickup.svg');
          break;
        case consts.OTIF_OLC:
        case consts.OTIF_DLC:
          image = require('@/assets/image/icon/ms-handling.svg');
          break;
        case consts.OTIF_ARRIVAL:
        case consts.OTIF_DEPARTURE:
          image =
            type === 'OCEAN'
              ? require('@/assets/image/icon/ms-ship.svg')
              : require('@/assets/image/icon/ms-airplane.svg');
          break;
        case consts.OTIF_COMPLETED:
          image = require('@/assets/image/icon/ms-complate-blue.svg');
          break;
        case 'REJECTED':
        case 'CANCELLED':
          image = require('@/assets/image/icon/ms-scheduled-air-purple.svg');
          break;
        case consts.OTIF_STARTED:
          if (active === true) {
            image = require('@/assets/image/icon/ms-started-blue.svg');
          } else {
            image = require('@/assets/image/icon/ms-started.svg');
          }
          break;
        case consts.OTIF_LOADING:
          if (active === true) {
            image = require('@/assets/image/icon/ms-loading-blue.svg');
          } else {
            image = require('@/assets/image/icon/ms-loading.svg');
          }
          break;
        case consts.OTIF_INTRANSIT:
          if (active === true) {
            image = require('@/assets/image/icon/ms-intransit-blue.svg');
          } else {
            image = require('@/assets/image/icon/ms-intransit.svg');
          }
          break;
        case consts.OTIF_UNLOADING:
          if (active === true) {
            image = require('@/assets/image/icon/ms-loading-blue.svg');
          } else {
            image = require('@/assets/image/icon/ms-loading.svg');
          }
          break;
        case consts.OTIF_DELIVERED:
          if (active === true) {
            image = require('@/assets/image/icon/ms-delivered-blue.svg');
          } else {
            image = require('@/assets/image/icon/ms-delivered.svg');
          }
          break;
        default:
          image = '';
      }
      return image;
    },

    getAdditional(customsClearance, clearanceDestination, estimateStorage) {
      const additional = [];
      if (customsClearance === 'true') {
        additional.push('Custom Clearance (Origin)');
      }
      if (clearanceDestination === 'true') {
        additional.push('Custom Clearance (Destination)');
      }
      if (estimateStorage === 'true') {
        additional.push('Estimatate Storage');
      }
      return additional.length > 0 ? additional.join(',\n') : '-';
    },

    getOtifColor(color) {
      let filter = '';
      const cssFilter = 'filter: ';
      switch (color) {
        case 'red':
          filter = `${cssFilter}invert(54%) sepia(25%) saturate(5166%) hue-rotate(326deg) brightness(78%) contrast(100%);`;
          break;
        case 'grey':
          filter = `${cssFilter}grayscale(1); opacity: 0.5;`;
          break;
        case 'green':
          filter = `${cssFilter}invert(58%) sepia(24%) saturate(715%) hue-rotate(66deg) brightness(99%) contrast(87%);`;
          break;
        case 'deepgreen':
          filter = `${cssFilter}invert(58%) sepia(24%) saturate(615%) hue-rotate(66deg) brightness(69%) contrast(47%);`;
          break;
        case 'blue':
          filter = `${cssFilter}invert(33%) sepia(58%) saturate(591%) hue-rotate(183deg) brightness(73%) contrast(100%);`;
          break;
        case 'purple':
          filter = `${cssFilter}invert(50%) sepia(9%) saturate(4861%) hue-rotate(235deg) brightness(89%) contrast(87%);`;
          break;
        default:
          filter = '';
      }
      return filter;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/getters/shipment-details.js